import { useEffect } from 'react';

import { useNavigate } from 'react-router';

import { useUser } from '@clerk/react-router';

import SubscriptionModal from '~/components/SubscriptionModal';
import { useModal } from '~/hooks/useModal';

// Utility function to log only on client side
const logOnClient = (level: 'info', message: string, data?: any) => {
  if (typeof window !== 'undefined') {
    console[level](`[Modals] ${message}`, data);
  }
};

export default function Modals() {
  const { type, isOpen, onClose, data } = useModal();
  const navigate = useNavigate();
  const { user } = useUser();

  // Add debugging for modal state
  useEffect(() => {
    console.log('Modals component state:', { type, isOpen, data });
  }, [type, isOpen, data]);

  // Handle processing route specific modal close behavior
  useEffect(() => {
    if (!isOpen && type === 'subscription') {
      const isProcessingRoute = window.location.pathname === '/processing';
      const hasSubscriptionSuccess =
        new URLSearchParams(window.location.search).get(
          'subscriptionSuccess'
        ) === 'true';

      if (isProcessingRoute && !hasSubscriptionSuccess) {
        logOnClient(
          'info',
          'Processing route modal close - setting up redirect check'
        );

        // Small delay to let any subscription success handling complete
        setTimeout(() => {
          const stillOnProcessing = window.location.pathname === '/processing';
          const stillNoSuccess =
            new URLSearchParams(window.location.search).get(
              'subscriptionSuccess'
            ) !== 'true';

          if (stillOnProcessing && stillNoSuccess) {
            logOnClient('info', 'Redirecting to practice route');
            navigate('/practice');
          } else {
            logOnClient('info', 'Subscription was successful, not redirecting');
          }
        }, 100);
      }
    }
  }, [isOpen, type, navigate]);

  const handleModalClose = () => {
    logOnClient('info', 'Modal close handler called');
    onClose();
  };

  return (
    <>
      {/* Subscription Modal */}
      {type === 'subscription' && (
        <SubscriptionModal
          isOpen={isOpen}
          onClose={handleModalClose}
          currentPlan={data.currentPlan || 'free'}
          context={data.context}
          isCancelled={data.isCancelled}
          renewalDate={data.renewalDate}
        />
      )}
    </>
  );
}
